import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FinalCTA({
  headline = "Ready to Write Your Next Chapter?",
  subtext = "Whether you're a business, a leader, or a professional in transition, we'd love to hear where you are and where you want to go.",
  ctaLabel = "Start the Conversation",
  to = "/contact",
}) {
  return (
    <section
      data-testid="final-cta"
      className="relative overflow-hidden bg-[#1E2761] text-white"
    >
      {/* Decorative grain / shapes */}
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none"
           style={{
             backgroundImage:
               "radial-gradient(circle at 20% 30%, #C9A84C 0%, transparent 40%), radial-gradient(circle at 80% 70%, #4A90D9 0%, transparent 40%)",
           }}
      />
      <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#C9A84C] to-transparent" />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 py-24 md:py-32 text-center">
        <div className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-[#C9A84C] mb-6">
          <span className="h-[1px] w-8 bg-[#C9A84C]" />
          Your Next Chapter
          <span className="h-[1px] w-8 bg-[#C9A84C]" />
        </div>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-tight tracking-tight mb-6">
          {headline}
        </h2>
        <p className="text-base md:text-lg text-white/75 max-w-2xl mx-auto leading-relaxed mb-10">
          {subtext}
        </p>
        <Link
          to={to}
          data-testid="final-cta-button"
          className="group inline-flex items-center gap-3 bg-[#C9A84C] text-[#1E2761] px-8 py-4 font-semibold tracking-wide hover:bg-white transition-colors duration-300"
        >
          {ctaLabel}
          <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </section>
  );
}
